import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { flowRight as compose } from 'lodash';
import { intlShape } from 'react-intl';

import Button from '../BuildingBlocks/Button';
import Grid from '../Utility/Grid';
import VerticalSpacing from '../Utility/VerticalSpacing';
import Text from '../BuildingBlocks/Text';
import { media } from '../css';
import messages from '../../messages/Map/messages';
import withAnalytics from '../../hocs/withAnalytics';

const ButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap-reverse;
  button {
    margin-bottom: 10px;
  }
  ${media.greaterThan('md')`
  button{
    margin: 0;
  }
  `};
`;

class WarningModal extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
    screenClass: PropTypes.string.isRequired,
    onContinueHook: PropTypes.func,
    onCloseHook: PropTypes.func
  };

  static defaultProps = {
    onContinueHook: () => {},
    onCloseHook: () => {}
  };

  render() {
    const { screenClass, onContinueHook, onCloseHook, intl } = this.props;

    return (
      <VerticalSpacing size="sm">
        <Grid.Container>
          <Grid.Row>
            <Grid.Col>
              <Text.HeadingFourth>{intl.formatMessage(messages.warningTitle)}</Text.HeadingFourth>
            </Grid.Col>
          </Grid.Row>
          <Grid.Row>
            <Grid.Col>
              <Text.CopyBody>{intl.formatMessage(messages.warningMessage)}</Text.CopyBody>
            </Grid.Col>
          </Grid.Row>
        </Grid.Container>
        <Grid.Container>
          <Grid.Row>
            <Grid.Col>
              <ButtonRow>
                <Button
                  onClick={() => {
                    onContinueHook();
                  }}
                  fullWidth={['xs', 'sm'].includes(screenClass)}
                >
                  Continue
                </Button>
                <Button
                  onClick={() => {
                    onCloseHook();
                  }}
                  fullWidth={['xs', 'sm'].includes(screenClass)}
                >
                  Cancel
                </Button>
              </ButtonRow>
            </Grid.Col>
          </Grid.Row>
        </Grid.Container>
      </VerticalSpacing>
    );
  }
}

export default compose(withAnalytics())(WarningModal);
